<template>
  <div>
    <div v-if="isPDF" class="pdf-viewer">
      <iframe :src="fileUrl" width="100%" height="500" frameborder="0"></iframe>
    </div>

    <div v-else-if="isImage" class="image-viewer">
      <img :src="fileUrl" alt="Document" style="max-width: 100%; height: auto;"/>
    </div>

    <div v-else class="file-download">
      <v-btn
        color="primary"
        :href="fileUrl"
        target="_blank"
        download
      >
        <v-icon left>mdi-download</v-icon>
        Download File
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileViewer',
  props: {
    fileUrl: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      required: true
    }
  },
  computed: {
    fileExtension() {
      return this.fileName.split('.').pop().toLowerCase();
    },
    isPDF() {
      return this.fileExtension === 'pdf';
    },
    isImage() {
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(this.fileExtension);
    }
  }
}
</script>

<style scoped>
.pdf-viewer, .image-viewer, .file-download {
  margin: 20px 0;
  text-align: center;
}
</style>